<template>
    <div>
        <div @click="openModal()" @mouseleave="leaveModal()"  @mouseenter="hoverModal()" class="signup-button text-sm text-red-500 font-medium">
            <img
                id="newsletterModalButton"
                class="inline mr-1"
                src="https://objects.kaxmedia.com/auto/o/192942/47091a6cf9.svg"
                alt=""
                width="20"
            />
            <img
                id="newsletterModalButtonHover"
                class="inline mr-1 hidden lg:hidden"
                src="https://objects.kaxmedia.com/auto/o/192943/f430e1d01f.svg"
                alt=""
                width="20"
            />
            <span id="newsletterModalText">Sign Up</span>
        </div>

        <div
            class="modal micromodal-slide modal-global-selector !w-full !text-black !bg-transparent"
            style="background: transparent"
            id="newsletterModal"
            aria-hidden="true"
        >
            <div class="relative container mx-auto h-full">
                <div class="modal__overlay" tabindex="-1" data-micromodal-close></div>
                <div
                    class="modal__container !rounded-xl"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-global-selector-title"
                >
                    <header class="modal__header flex flex-row-reverse">
                        <button
                            class="modal__close__button"
                            aria-label="Close modal"
                            data-micromodal-close
                            @click="closeModal()"
                        >
                            <img
                                class="close-button ls-is-cached lazyloaded"
                                style="margin-top: 20px; margin-right: 20px"
                                data-dismiss="modal"
                                data-src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg"
                                src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg"
                            />
                        </button>
                    </header>
                    <main class="modal__content" id="modal-global-selector-content">
                        <div class="wrapper subscription-container">
                            <div class="hero-image">
                                <img
                                    class="m-auto"
                                    src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg"
                                    alt=""
                                />
                            </div>
                            <div
                                class="hero-title w-100"
                                v-html="translations.subscription_modal_title"
                            >
                                Put <span class="red">Gambling.com</span> in Your Inbox
                            </div>
                            <div class="hero-text w-100">
                                {{ translations.subscription_modal_text }}
                            </div>
                            <div id="subscription-form-subscribe">
                                <subscription-form-tw></subscription-form-tw>
                            </div>
                        </div>
                        <div class="newsletter-subscription-response hidden">
                            <div class="hero-image">
                                <img
                                    class="m-auto"
                                    src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg"
                                    alt=""
                                />
                            </div>
                            <div
                                class="hero-title w-100"
                                v-html="translations.subscribed_title"
                            ></div>
                            <div
                                class="hero-text w-100"
                                v-html="translations.subscribed_text"
                            ></div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: null,
            translations: {
                email_enter_email: null,
                subscribed_title: null,
                subscribed_text: null,
                subscription_modal_title: null,
                subscription_modal_text: null,
                subscribe_button_text: null,
                agree_message: null,
                input_validation_error: null,
                checkbox_validation_error: null,
                email_validation_error: null,
            },
            modalOpen: false,
            micromodal: null,
        };
    },
    mounted() {
        this.translations = this.$root.translations;
      
    },
    methods: {
        openModal() {
            closeMobileNav();
            MicroModal.show('newsletterModal', {
                onShow: modal => {
                this.modalOpen = true;
                },
                onClose: modal => {
                    this.modalOpen = false;
                    this.leaveModal();
                },
            })
        },
        leaveModal() {
            if(this.modalOpen) return;
            $('#newsletterModalButton').removeClass('lg:hidden');
            $('#newsletterModalButtonHover').removeClass('lg:inline');
            $('#newsletterModalButtonHover').addClass('lg:hidden');
            $('#newsletterModalText').removeClass('lg:text-black lg:underline');
        },
        hoverModal: function () {
            $('#newsletterModalButton').addClass('lg:hidden');
            $('#newsletterModalButtonHover').addClass('lg:inline');
            $('#newsletterModalButtonHover').removeClass('lg:hidden');
            $('#newsletterModalText').addClass('lg:text-black lg:underline');
        },
        closeModal: function () {
            this.modalOpen = false;
            this.leaveModal();
            MicroModal.close('newsletterModal');
        },
        send: function () {},
    },
};
</script>
